import React from 'react';
import MaintenanceBackground from '../../components/MaintenanceBackground/MaintenanceBackground';
import MountainRange from '../../components/MountainRange/MountainRange';
import StatusBadge from '../../components/StatusBadge/StatusBadge';
import './MaintenancePage.css';

/**
 * Full-screen "site under maintenance" splash page.
 * Same markup renders both the desktop and mobile layouts from the
 * design — responsiveness is handled entirely through CSS.
 */
function MaintenancePage({
  badgeLabel = 'Fuera de servicio temporalmente',
  title = 'Estamos en un proceso de mejora-this is a test',
  signature = 'Firmado el equipo de FLIK',
}) {
  return (
    <main className="MaintenancePage">
      <MaintenanceBackground />

      <div className="MaintenancePage-content">
        <StatusBadge label={badgeLabel} />
        <h1 className="MaintenancePage-title">{title}</h1>
        <span className="MaintenancePage-divider" aria-hidden="true" />
        <p className="MaintenancePage-signature">{signature}</p>
      </div>

      <MountainRange />
    </main>
  );
}

export default MaintenancePage;
